<template>
  <v-container>
    <h2>EVENTOS</h2>
    <v-row>
        <v-col>
            <v-checkbox label="Solo este año" v-model="filterThisYearOnly"></v-checkbox>
        </v-col>
    </v-row>
    <GlobalEventProcessIndex
        :storeModel="storeModel"
        :filterThisYearOnly="filterThisYearOnly"
        :permissionRoot="'Eventos,Doyang Eventos'"
    />
  </v-container>
</template>

<script>
import GlobalEventProcessIndex from '../globals/CRUDEventProcessIndex'
export default {
  components: {
    GlobalEventProcessIndex
  },
  data () {
    return {
      filterThisYearOnly: true,
      storeModel: 'Event'
    }
  }
}
</script>

<style>

</style>
